module.exports = __webpack_public_path__ + "static/media/ic-arrow-up-white.206c2de6.svg";